export default {

  data: () => ({
    page: 1,
    defaultPage: 1,
    pageParameter: 'page',

    perPage: 20,
    defaultPerPage: 20,
    perPageParameter: 'perPage',

    hasNextPage: null,
    hasPreviousPage: null,
  }),

  created() {
    this.initializePaginationFromQueryString();
  },

  methods: {
    initializePaginationFromQueryString() {
      this.page = parseInt(this.$route.query[this.pageParameter] || this.defaultPage, 10);
      this.perPage = parseInt(this.$route.query[this.perPageParameter] || this.defaultPerPage, 10);
    },
    selectNextPage() {
      this.page += 1;
    },
    selectPreviousPage() {
      this.page -= 1;
    },
    updatePerPage(value) {
      this.perPage = value;
    },
    setPagination(links) {
      this.hasPreviousPage = links && links.prev !== null;
      this.hasNextPage = links && links.next !== null;
    },
  },
};
